import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import { useRoute } from 'vue-router'
import axios from '@/axios'
import { useStore } from 'vuex'
import emitter from '@/eventBus'
const progress = ref({ "type": "update", "msg": "0" })
const index_update = ref({})
import router from "@/router"

const useApp = () => {

    const store = useStore()

    const host = window.location.origin

    const toast = useToast()

    // const swal = inject('$swal')

    const route = useRoute()

    const ToastMsg = (msg, icon, time) => {
        toast(msg, {
            timeout: time,
            icon: `fas fa-${icon}`,
        })
    }
    const ToastMsgError = (msg, icon, time) => {
        toast.error(msg, {
            timeout: time,
            icon: `fas fa-${icon}`,
        })
    }
    const ToastMsgWarning = (msg, icon, time) => {
        toast.warning(msg, {
            timeout: time,
            icon: `fas fa-${icon}`,
        })
    }
    const ToastMsgInfo = (msg, icon, time) => {
        toast.info(msg, {
            timeout: time,
            icon: `fas fa-${icon}`,
        })
    }
    const ToastMsgSuccess = (msg, icon, time) => {
        toast.success(msg, {
            timeout: time,
            icon: `fas fa-${icon}`,
        })
    }


    const reloadPage = (url, time) => {
        const timeOut = setTimeout(() => {
            window.location = `/${url}`
            clearTimeout(timeOut)
        }, time)
    }

    const command = (cmd) => {
        ws.value.send(cmd)
    }

    const validEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    const logOut = () => {
        console.log("logout");
        localStorage.clear();
        window.location.href = "/login";
    }

    const getQueryParam = (param) => {
        location.search.substr(1)
            .split("&")
            .some(function (item) { // returns first occurence and stops
                return item.split("=")[0] == param && (param = item.split("=")[1])
            })
        return param
    }

    const onMessage = (type, callback, msg) => {
        if (msg.type == type) {
            return callback(data.value)
        }
    }

    const selectDevice = (index) => {
        const device = store.state.devices[index];
        const axiosHeaders = {
            headers: {
                token: store.state.auth.token
            }
        }
        const toSend = {
            dId: device.dId
        };

        axios.put("/device", toSend, axiosHeaders).then(() => {
            store.dispatch("getDevices");
            store.commit("setDeviceInfo", null);
            store.commit("setDeviceActive", false);
            store.commit("setDeviceLastTime", null)
            if (store.state.mqtt_connected){
                setTimeout(() => emitter.emit("connected-mqtt", { connected: true }), 1000)
                router.push("/")
            }
        })

    }

    const restartDevice = () => {
        const topic =
            store.state.auth.userData._id +
            "/" +
            store.state.selectedDevice.dId +
            "/reboot/actdata"
        const toSend = {
            topic,
            msg: {}
        }
        emitter.emit("mqtt-sender", toSend)

        ToastMsgInfo("Solcitud de Reinicio Enviada !", "server", 5000)
    }

    const unixToDate = (ms) => {
        var d = new Date(parseInt(ms)),
            yyyy = d.getFullYear(),
            mm = ("0" + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
            dd = ("0" + d.getDate()).slice(-2), // Add leading 0.
            hh = d.getHours(),
            h = hh,
            min = ("0" + d.getMinutes()).slice(-2), // Add leading 0.
            ampm = "AM",
            time;

        if (hh > 12) {
            h = hh - 12;
            ampm = "PM";
        } else if (hh === 12) {
            h = 12;
            ampm = "PM";
        } else if (hh == 0) {
            h = 12;
        }

        // ie: 2013-02-18, 8:35 AM
        time = dd + "/" + mm + "/" + yyyy + ", " + h + ":" + min + " " + ampm;

        return time;
    }

    const updateTemplate = async (data) => {
        try {
            let widgets_store = JSON.parse(JSON.stringify(store.state.selectedDevice.template.widgets))            
            data.templates.forEach( arr => {
                widgets_store.forEach( (obj, index) => {
                    if (arr[0] == obj.variable){
                        if (arr[1] != obj.variableFullName){
                            widgets_store[index].variableFullName = arr[1]
                        }
                        
                    }
                })
            })
            
            const templateId = store.state.selectedDevice.templateId
            const axiosHeaders = {
                headers: {
                    token: store.state.auth.token
                }
            }
            const toSend = {
                templateId,
                widgets: widgets_store
            }

            axios.put("/template", toSend, axiosHeaders).then((res) => {
                if (res.data.status == "success") {
                    ToastMsgSuccess("Plantilla Actualizada", "server", 5000);
                    store.dispatch("getDevices");
                }
            }).catch((err) => {
                ToastMsgError("Error Actualizando Plantilla", "server", 5000)
            })
        } catch (err) {
            console.log("Error Creating Template")
            console.log(err)
        }

    }

    const getTimeAgo = (seconds) => {
        if (seconds < 0) {
            seconds = 0;
        }

        if (seconds < 59) {
            return seconds.toFixed() + " secs";
        }

        if (seconds > 59 && seconds <= 3600) {
            seconds = seconds / 60;
            return seconds.toFixed() + " min";
        }

        if (seconds > 3600 && seconds <= 86400) {
            seconds = seconds / 3600;
            return seconds.toFixed() + " hour";
        }

        if (seconds > 86400) {
            seconds = seconds / 86400;
            return seconds.toFixed() + " day";
        }
    }

    const showPassword = (input_id, toggle_id) => {
        const passwordInput = document.getElementById(input_id);
        const toggleIcon = document.getElementById(toggle_id);

        if (passwordInput.type === "password") {
          passwordInput.type = "text";
          toggleIcon.classList.remove("fa-eye");
          toggleIcon.classList.add("fa-eye-slash");
        } else {
          passwordInput.type = "password";
          toggleIcon.classList.remove("fa-eye-slash");
          toggleIcon.classList.add("fa-eye");
        }
      }



    return {
        ToastMsg,
        ToastMsgError,
        ToastMsgWarning,
        ToastMsgInfo,
        ToastMsgSuccess,
        // swal,
        host,
        progress,
        reloadPage,
        command,
        route,
        index_update,
        validEmail,
        logOut,
        getQueryParam,
        onMessage,
        selectDevice,
        unixToDate,
        restartDevice,
        updateTemplate,
        getTimeAgo,
        showPassword,
    }

}

export default useApp
